// Func = limiting Scope for this file
var lastScrollTop = 0;


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    }; 
}

(function(){

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        //is explorer
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        let scrollParallax = []
        let scrolled = 0

        // screen height
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
            //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/
    }

    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    // if(textModule){
    //     textModule.forEach(function(text_module) {
    //         text_module.classList.add('animate-fade', 'top');
    //     });
    // } 

    let Body = document.body;
    let BurgerMenu = document.getElementById('js_btn_menu');
    let NavigationBox = document.getElementById('navigationBox');
    let CloseNav = document.getElementById('js_navigation_close');

    if(BurgerMenu){
        BurgerMenu.addEventListener('click', function(e){
            e.preventDefault();
            NavigationBox.classList.add('open');
            Body.classList.add('scroll-no');
        });
    }

    if(CloseNav){
        CloseNav.addEventListener('click', function(e){
            e.preventDefault();
            NavigationBox.classList.remove('open');
            Body.classList.remove('scroll-no');
        });
    }

    let BookingBox = document.getElementById('bookBox');
    let BookClose = document.getElementById('js_book_close');

    if(BookClose){
        BookClose.addEventListener('click', function(e){
            e.preventDefault();
            BookingBox.classList.remove('open');
            Body.classList.remove('scroll-no');
        });
    }

    document.addEventListener('DOMContentLoaded', () => {

        // Main Nav Dropdown
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

        $("#closeFake, #adults_home").click(function(){
            $('#fakeInput').fadeOut();
        })

        $("input[name=zip_code]").attr("maxlength", "5");

    });

    window.onload = function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        })
    };

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: true
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        accessibility: true
    });

    $('.reviews-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        adaptiveHeight: true
    });

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true
    });
    $('.gallery-slider .gallery-grid').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: false,
        slidesToShow:5,
        accessibility:true,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            { 
                breakpoint: 990,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.gallery-slider-grid').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.slider-bg-content').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                }
            }
        ]
    });
    $('.images-mini').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        focusOnSelect: true
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.getElementById('home');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            entry.style.height = screenHeight+'px';
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                entry.style.height = screenHeight+'px';
            });
        });
    }

    //Progressbar Header

    let timeHeader = 2;
    let $barHeader, isPauseHeader, tickHeader, percentTimeHeader, $sliDerHeader;

    $barHeader = $('.slider-progress-header .progress');
    $sliDerHeader = $('.top-img.sym-slides');
    function startProgressbarHeader() {
        resetProgressbarHeader();
        percentTimeHeader = 0;
        isPauseHeader = false;
        tickHeader = setInterval(intervalHeader, 40);
    }

    function intervalHeader() {
        if (isPauseHeader === false) {
            percentTimeHeader += 1 / (timeHeader + 0.1);
            $barHeader.css({
                height: percentTimeHeader + "%"
            });
            if (percentTimeHeader >= 100) {
                $sliDerHeader.slick('slickNext');
                startProgressbarHeader();
            }
        }
    }

    function resetProgressbarHeader() {
        $barHeader.css({
            height: 0 + "%"
        });
        clearTimeout(tickHeader);
    }

    $('.top-img.sym-slides').on('beforeChange', function(){
        startProgressbarHeader();
    });

    $('.top-img.sym-slides .slick-next, .top-img.sym-slides .slick-prev, .top-img.sym-slides .top-img.slick-dots button').click(function() {
        startProgressbarHeader();
    });
    startProgressbarHeader();

})();



function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
//ScrollW
function scrollW(){
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            // downscroll code
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            // upscroll code
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }

    const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
/*MOBILE MENU NAV
	****************************************************************/

//Open Navigation
$('#menu-btn,.burger-js').click(function (event) {
	event.preventDefault();
	$('html').addClass('hide-overflow');
	$('.navigation').addClass('open');
	$('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
	if ($('.navigation ul li a').hasClass('.item-open')) {
		$(".item-open").get(0).scrollIntoView(false);
	}
});

$('.close-menu').click(function (event) {
	event.preventDefault();
	$('html').removeClass('hide-overflow');
	$('.navigation').removeClass('open');
	$('.navigation').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
});
